import { PrivilegeChecker } from 'omni-common-ui';
import Privileges from 'domain/Privileges';
import AcademicInfo from './component';
import { routes as academicInfoGroups } from './AcademicInfoGroups';
import { routes as concerns } from './Concerns';

export const TODAY = 'today';
export const ALL_GROUPS = 'all-groups';
export const CONCERNS = 'concerns';

export default ({ getState }) => ({
  path: '/academic-info',
  component: AcademicInfo,
  indexRoute: {
    onEnter: ({ location, params }, replace) =>
      replace(`${withoutTrailingSlash(location.pathname)}/${TODAY}`),
  },
  canAccess: () =>
    PrivilegeChecker.hasPrivilege(getState(), Privileges.AcademicInfo.View),
  tab: {
    label: 'ACADEMIC INFO',
    order: 2,
    isVisible: () =>
      PrivilegeChecker.hasPrivilege(getState(), Privileges.AcademicInfo.View),
  },
  secondLevelTabs: ({ location: { pathname }, push, buildRoute }) => [
    {
      text: 'TODAY\'S GROUPS',
      onClick: () => push(buildRoute(`/academic-info/${TODAY}`)),
      isActive: pathname.indexOf(TODAY) > 0,
    },
    {
      text: 'ALL GROUPS',
      onClick: () => push(buildRoute(`/academic-info/${ALL_GROUPS}`)),
      isActive: pathname.indexOf(ALL_GROUPS) > 0,
    },
    {
      text: 'CONCERNS',
      onClick: () => push(buildRoute(`/academic-info/${CONCERNS}`)),
      isActive: pathname.indexOf(CONCERNS) > 0,
    },
  ],
  childRoutes: [
    academicInfoGroups,
    concerns,
  ],
});

function withoutTrailingSlash(path) {
  let out = path;
  if (path.substr(path.length - 1) === '/') {
    out = path.substr(0, path.length - 1);
  }
  return out;
}



// WEBPACK FOOTER //
// ./containers/UserDashboard/AcademicInfo/routes.js